<script>
import { Editor } from '@toast-ui/vue-editor'
import '@toast-ui/editor/dist/toastui-editor.css'
import noticeApi from './notice'

// const NOTICE_SUB_CODE = 128

export default {
  name: 'NoticeForm',
  components: {
    Editor
  },
  data () {
    return {
      userInfo: {},
      userInfoDetail: {},
      noticePid: null,
      subject: '',
      content: '',
      showPopup: false,
      saving: false,
      editorOptions: {
        language: 'ko-KR',
        hideModeSwitch: true,
        usageStatistics: false
      }
    }
  },
  created () {
    this.userInfo = this.getUserInfo()
    this.userInfoDetail = this.getUserInfoDetail()

    if (!this.checkNoticeManageAuth(true)) {
      this.$router.replace({
        name: 'NoticeList'
      })
      return
    }

    this.noticePid = this.$route.query.noticePid || null

    if (this.isEditMode) {
      this.getNoticeDetail()
    }
  },
  computed: {
    isEditMode () {
      return this.noticePid != null && this.noticePid !== ''
    },
    canManageNotice () {
      const userRole = Number(this.userInfoDetail && this.userInfoDetail.userRole)

      return userRole === 1 || userRole === 5
    },
    pageTitle () {
      return this.isEditMode ? '공지사항 수정' : '공지사항 등록'
    }
  },
  methods: {
    getUserInfo () {
      let userInfo = {}

      try {
        userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}') || {}
      } catch (e) {
        userInfo = {}
      }

      return userInfo
    },
    getUserInfoDetail () {
      let userInfoDetail = {}

      try {
        userInfoDetail = JSON.parse(sessionStorage.getItem('userInfoDetail') || '{}') || {}
      } catch (e) {
        userInfoDetail = {}
      }

      return userInfoDetail
    },
    checkNoticeManageAuth (silent) {
      if (this.canManageNotice) return true

      if (!silent) {
        alert('공지사항 관리 권한이 없습니다.')
      }

      return false
    },
    isSuccess (response) {
      const data = response && response.data ? response.data : response
      return !data || data.resultCode === undefined || data.resultCode === 1 || data.resultCode === '1'
    },
    normalizeDetailResponse (response) {
      const data = response && response.data ? response.data : response
      const result = data && data.result !== undefined ? data.result : data
      const body = result && result.body !== undefined ? result.body : result

      if (!body || typeof body !== 'object' || Array.isArray(body)) {
        return null
      }

      return {
        noticePid: body.noticePid,
        userPid: body.userPid,
        subject: body.subject || '',
        content: body.content || '',
        showPopup: !!body.showPopup,
        regDate: body.regDate || '',
        updDate: body.updDate || ''
      }
    },
    getNoticeDetail () {
      noticeApi.getNotice({
        noticePid: this.noticePid
      }, response => {
        console.log(`getNotice noticePid: ${this.noticePid}`, response)
        if (!this.isSuccess(response)) {
          alert('공지사항을 불러오지 못했습니다.')
          this.goList()
          return
        }

        const notice = this.normalizeDetailResponse(response)

        if (!notice) {
          alert('공지사항 정보를 불러오지 못했습니다.')
          this.$router.push({ name: 'NoticeList' })
          return
        }

        this.subject = notice.subject || ''
        this.content = notice.content || ''
        this.showPopup = !!notice.showPopup

        this.$nextTick(() => {
          if (!this.$refs.toastEditor) return

          try {
            this.$refs.toastEditor.invoke('setHTML', this.content || '')
          } catch (e) {
            try {
              this.$refs.toastEditor.invoke('setHtml', this.content || '')
            } catch (e2) {}
          }
        })
      })
    },
    validate () {
      const subject = this.subject ? this.subject.trim() : ''
      const editorValue = this.getEditorValue()
      const content = editorValue.html

      if (!subject) {
        alert('제목을 입력해주세요.')
        return false
      }

      if (this.isEmptyEditorContent(editorValue.html, editorValue.markdown)) {
        alert('내용을 입력해주세요.')
        return false
      }

      this.subject = subject
      this.content = content
      this.showPopup = !!this.showPopup

      return true
    },
    getEditorValue () {
      const editor = this.$refs.toastEditor

      if (!editor) {
        return {
          html: this.content || '',
          markdown: ''
        }
      }

      let html = ''
      let markdown = ''

      try {
        html = editor.invoke('getHTML') || ''
      } catch (e) {
        try {
          html = editor.invoke('getHtml') || ''
        } catch (e2) {
          html = ''
        }
      }

      try {
        markdown = editor.invoke('getMarkdown') || ''
      } catch (e) {
        markdown = ''
      }

      return {
        html: html,
        markdown: markdown
      }
    },
    syncEditorContent () {
      const editorValue = this.getEditorValue()
      this.content = editorValue.html
    },
    isEmptyEditorContent (html, markdown) {
      const htmlValue = html || ''
      const markdownValue = markdown || ''

      // 이미지, 동영상, iframe, table 등 텍스트가 없어도 실제 콘텐츠로 봐야 하는 요소
      const hasHtmlContent = /<(img|video|audio|iframe|table)\b/i.test(htmlValue)

      // TOAST UI Editor에서 이미지가 마크다운 문법으로만 잡히는 경우 대응
      const hasMarkdownImage = /!\[[^\]]*\]\([^)]+\)/.test(markdownValue)

      if (hasHtmlContent || hasMarkdownImage) {
        return false
      }

      const textContent = htmlValue
        .replace(/<style[\s\S]*?<\/style>/gi, '')
        .replace(/<script[\s\S]*?<\/script>/gi, '')
        .replace(/<br\s*\/?>/gi, '')
        .replace(/<\/p>/gi, '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, '')
        .replace(/&#160;/gi, '')
        .replace(/\s/g, '')
        .trim()

      return textContent.length <= 0
    },
    saveNotice () {
      if (!this.checkNoticeManageAuth()) return
      if (this.saving || !this.validate()) return

      const body = {
        subject: this.subject,
        content: this.content,
        showPopup: this.showPopup
      }

      if (this.isEditMode) {
        body.noticePid = this.noticePid
      }

      this.saving = true

      const successCallback = response => {
        console.log(`${this.isEditMode ? 'post' : 'put'}Notice`, response)
        this.saving = false

        if (!this.isSuccess(response)) {
          alert('공지사항 저장에 실패했습니다.')
          return
        }

        alert('저장되었습니다.')
        this.goList()
      }

      const errorCallback = error => {
        console.error(`${this.isEditMode ? 'post' : 'put'}Notice`, error)
        this.saving = false

        const status = error && error.response ? error.response.status : null

        if (status >= 500) {
          alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
        } else {
          alert('공지사항 저장 중 오류가 발생했습니다.')
        }
      }

      if (this.isEditMode) {
        noticeApi.postNotice('post', body, successCallback, errorCallback)
      } else {
        noticeApi.putNotice('put', body, successCallback, errorCallback)
      }
    },
    deleteNotice () {
      if (!this.checkNoticeManageAuth()) return
      if (!this.isEditMode || !this.noticePid) return
      if (!window.confirm('삭제하시겠습니까?')) return

      noticeApi.deleteNotice('delete', {
        noticePid: this.noticePid
      }, response => {
        console.log(`deleteNotice noticePid: ${this.noticePid}`, response)
        if (!this.isSuccess(response)) {
          alert('공지사항 삭제에 실패했습니다.')
          return
        }

        alert('삭제되었습니다.')
        this.goList()
      }, error => {
        this.saving = false

        const status = error && error.response ? error.response.status : null

        if (status >= 500) {
          alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
        } else {
          alert('공지사항 삭제 중 오류가 발생했습니다.')
        }
      })
    },
    goList () {
      this.$router.push({
        name: 'NoticeList',
        query: {
          page: this.$route.query.page || 1,
          size: this.$route.query.size || 10
        }
      })
    }
  }
}
</script>

<template>
  <div id="notice_form">
    <div class="common_tit_wrap">
      <div class="common_page_tit">{{ pageTitle }}</div>
    </div>

    <div class="common_form_wrap">
      <div class="common_form_box">
        <div class="common_form_box_tit">기본정보</div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap half_width">
            <label>제목<span class="fc_red">*</span></label>
            <div>
              <input type="text" v-model="subject" maxlength="100" placeholder="제목을 입력해주세요"/>
            </div>
          </div>
          <div class="common_form_input_wrap half_width notice_popup_field">
            <label>팝업 출력<span class="fc_red">*</span></label>
            <div>
              <label class="notice_checkbox_label">
                <input type="checkbox" v-model="showPopup"/>
                <span>메인 화면 팝업으로 출력</span>
              </label>
            </div>
          </div>
        </div>
        <div class="common_form_box_content">
          <div class="common_form_input_wrap">
            <label>내용<span class="fc_red">*</span></label>
            <div class="notice_editor_wrap">
              <editor
                ref="toastEditor"
                :initial-value="content"
                :options="editorOptions"
                initial-edit-type="wysiwyg"
                height="500px"
                @change="syncEditorContent"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="common_bottom_wrap notice_form_bottom">
        <div class="btn_close" @click="goList">목록</div>
        <div v-if="isEditMode" class="btn_bottom btn_red" @click="deleteNotice">삭제</div>
        <div class="btn_blue" @click="saveNotice">{{ saving ? '저장중...' : '저장' }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#notice_form {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

.notice_popup_field input[type=checkbox] {
  width: auto;
  height: auto;
  margin: auto 8px auto 0;
}

.notice_checkbox_label {
  display: flex;
  margin: auto 0;
  color: #36414F;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.notice_editor_wrap {
  display: block !important;
  width: 100%;
  margin-top: 8px;
}

.notice_form_bottom > .btn_close {
  margin: auto auto auto 0;
  text-align: center;
}

.notice_form_bottom > .btn_red_t {
  margin: auto 0;
  text-align: center;
}

.notice_form_bottom > .btn_blue {
  margin: auto 0 auto 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeForm.vue